<template>
  <div class="p-tab-pane fade" v-show="show" :class="{in: changeIn}">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "PTabPane",
    props: {
      label: {
        type: String,
        default: ''
      },
      name: {
        type: [String, Number],
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        loaded: false,
        changeIn: false

      }
    },
    computed: {
      show(){
        if(this.$parent.currentName === this.name){
          if(!this.loaded){
            this.loaded = true;
            setTimeout(() => {
              this.changeIn = true;
            }, 20);
          }
          setTimeout(() => {
            this.changeIn = true;
          }, 20);
          return true;
        }
        setTimeout(() => {
          this.changeIn = false;
        }, 20);
        return false;
      }
    },
    watch: {
      label(){
        // label更新的时候强制更新父组件，以触发PTabNav才能更新
        this.$parent.$forceUpdate();
      }
    },
    mounted() {
      // 当当前组件创建的时候将当前组件添加到父组件的pTabPanes中，以触发PTabNav才能更新
      this.$parent.addPane(this);
    },
    destroyed() {
      if(this.$el && this.$el.parentNode){
        this.$el.parentNode.removeChild(this.$el);
      }
      // 当当前组件销毁时需从父组件中的pTabPanes中移除当前组件，以触发PTabNav才能更新
      this.$parent.removePane(this);
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/p-tabs/PTabPane.vue